import Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { Flex, Grid, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { getMedianAbsoluteDeviation } from 'utils/charts';
import { Legend } from '../Legend';

const PPG_SIGNAL_MAD_NEGATIVE_MULTIPLIER = 5;
const PPG_SIGNAL_MAD_POSITIVE_MULTIPLIER = 9;

interface PpgChartProps {
  chartOptions: Highcharts.Options;
  rawSignal?: number[];
}

export const PpgChart = ({ chartOptions, rawSignal }: PpgChartProps) => {
  const { t } = useTranslation();
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (!chart || !rawSignal?.length) return;

    const mad = getMedianAbsoluteDeviation(rawSignal);
    chart.yAxis[0].setExtremes(-mad * PPG_SIGNAL_MAD_NEGATIVE_MULTIPLIER, mad * PPG_SIGNAL_MAD_POSITIVE_MULTIPLIER);
    chart.showResetZoom();
  }, [rawSignal]);

  return (
    <Grid align={'center'}>
      <Grid.Col span={12}>
        <Flex justify={'space-between'}>
          <Title order={4}>{t('patients_ppg_title')}</Title>
        </Flex>
        <Legend
          items={[
            { color: 'var(--mantine-color-gray-5)', title: t('indicator_label_quality') },
            {
              color: 'var(--mantine-color-turquoise-3)',
              title: t('heartbeat_label'),
              innerColor: 'var(--mantine-color-red-5)',
            },
          ]}
        />
        <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />
      </Grid.Col>
    </Grid>
  );
};
